import React from 'react';

// 定义组件接收的属性类型
interface CloseLineProps {
  /** 图标的颜色，默认值为#505259 */
  color?: string;
}

/**
 * 关闭图标组件，支持自定义颜色、大小等属性
 */
export const CloseLine: React.FC<CloseLineProps> = ({ color = '#505259' }) => {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.220061 0.220062C-0.0728318 0.512955 -0.0736133 0.988612 0.21928 1.28151L3.93786 5.00009L0.219279 8.71868C-0.0736139 9.01157 -0.0728318 9.48723 0.220061 9.78012C0.512954 10.073 0.98861 10.0738 1.2815 9.7809L5.00008 6.06232L8.71863 9.78087C9.01153 10.0738 9.48718 10.073 9.78007 9.78009C10.073 9.4872 10.0737 9.01154 9.78086 8.71864L6.06231 5.00009L9.78086 1.28154C10.0737 0.988644 10.073 0.512987 9.78007 0.220094C9.48718 -0.0727993 9.01152 -0.0735809 8.71863 0.219313L5.00008 3.93787L1.2815 0.219279C0.98861 -0.073614 0.512954 -0.0728319 0.220061 0.220062Z'
        fill={color}
      />
    </svg>
  );
};
